import { Badge, Box, Table } from "@chakra-ui/react";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { Term } from "../../../../services/Dtos";
import { mapSession } from "../../../../services/Utils";
import { useEffect, useState } from "react";
import SettingsCard from "../../../CustomUi/SettingsCard";

interface Props {
  term: Term;
  handleClick: () => void;
}

export default function TermCard({ term, handleClick }: Props) {
  const { school, sessions, accentColor } = useSchoolsContext();

  const [, setSessionMap] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    if (sessions) {
      const map = mapSession(sessions);
      setSessionMap(map);
    }
  }, [sessions]);

  return (
    <SettingsCard handleClick={handleClick} minW={"270px"}>
      <Box position="absolute" top={0} left={0} display="flex" gap={1}>
        {term.id === school?.currentTermId && (
          <Badge fontSize="xs" colorPalette="green">
            Current
          </Badge>
        )}
        {term.id === school?.leapTermId && (
          <Badge fontSize="xs" colorPalette="red">
            Leap
          </Badge>
        )}
      </Box>
      <Table.Root fontSize={"sm"} variant={"outline"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Term Name</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <Badge variant={"outline"} colorPalette={accentColor} size={"md"}>
                {term.termName}
              </Badge>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Order</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {term.order}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </SettingsCard>
  );
}
